export const CONTRACT_GENERATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.ContractGeneration.ContractGenerated";
